import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material'
import * as React from 'react'
import { useState } from 'react'
import { useMutation, useQueryClient, UseQueryResult } from 'react-query'
import { AxiosResponse } from 'axios'
import { tsLimsOrder } from '../../../Typescript/API_Response'
import DeliveryDetailsFields from '../SaleCheckout/DeliveryDetailsFields'
import PyAPI from '../../../APIs/Python/APIs/PyAPI'
import { useUserContext } from '../../../Contexts/UserConfig'
import { useParams } from 'react-router-dom'
import { useMessagePopupContext } from '../../../garvan-react/Components/ModalFeedback/MessagePopup'
import { LoadingButton } from '@mui/lab'

function ChangeDeliveryDialog({
  open,
  setOpen,
  orderQuery,
}: {
  open: string | undefined
  setOpen: any
  orderQuery: UseQueryResult<tsLimsOrder, AxiosResponse<any, any>>
}) {
  const { whoAmI } = useUserContext()
  const { order_id } = useParams()
  const queryClient = useQueryClient()
  const { setError } = useMessagePopupContext()
  const [editOrder, setEditOrder] = useState({})

  const { mutate: updateIssue, isLoading } = useMutation<any, AxiosResponse>(
    () => PyAPI.patch(whoAmI, `/lims/issue/${order_id}`, editOrder),
    {
      onError: (err) => setError(err),
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: ['PyAPI', '/lims/issues'],
        })
        await queryClient.invalidateQueries({
          queryKey: ['PyAPI', '/lims/issue'],
        })
        setOpen(undefined)
        setEditOrder({})
      },
    },
  )
  return (
    <Dialog
      aria-label={'Change Delivery Dialog'}
      open={open === 'update'}
      onClose={() => setOpen(undefined)}
    >
      <DialogTitle>{'Update Shipment Details'}</DialogTitle>
      <DialogContent sx={{ minWidth: '500px' }}>
        <Box sx={{ width: 1, my: 1 }}>
          <DeliveryDetailsFields
            savedData={orderQuery.data}
            setFields={setEditOrder}
            fields={editOrder}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => setOpen(undefined)}
          color="error"
        >
          Cancel
        </Button>
        <LoadingButton
          onClick={() => updateIssue()}
          color="success"
          loading={isLoading}
        >
          Update
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}

export default ChangeDeliveryDialog
